<template>
<div>
    <UFormGroup label="Client Name" name="name" class="mb-5">
      <UInput v-model="client.name" />
    </UFormGroup>

    
</div>
</template>

<script setup lang="ts">
import moment from 'moment';
import type { Client } from '~/common/types/types';

const client = defineModel({
  required: true,
  type: Object as PropType<Client>   
})
</script>